import Http from '@/services/http';
import {
  AlarmDetailRequest,
  AlarmDetailResponse,
  AlarmEventsRequest,
  AlarmEventsResponse,
  AlarmByInstallationRequest,
  AlarmByInstallationResponse,
  AlarmByCompanyRequest,
  AlarmByCompanyResponse,
} from 'sigma-mappings';

const urls = {
  getAlarmsByCompany: 'Alarme/resumo-por-empresa',
  getAlarmsDetailsByInstallation: 'Alarme/detalhes',
  getAlarmDetails: ({ alarmeAnunciadorId }) => `Alarme/${alarmeAnunciadorId}`,
  getAlarmEvents: ({ alarmeAnunciadorId }) => `Alarme/eventos/${alarmeAnunciadorId}`,
};

export default {
  /**
   * Obtém um resumo da totalização dos alarmes por empresa/regional/instalação.
   * @param {*} params com os filtros para alarme
   * busca por nome da empresa/instalação/regional, do status do alarme
   * e das classificações do alarme
   */
  getAlarmsByCompany(params) {
    const http = new Http();
    const mappedPayload = new AlarmByCompanyRequest(params);
    return http.post(urls.getAlarmsByCompany, mappedPayload)
      .then(({ data }) => data.map(item => new AlarmByCompanyResponse(item)));
  },
  /**
   Obtém uma listagem de detalhes de alarmes por instalação.
   * @param {*} params
   * busca por id da instalação, pelo status do alarme e
   * pelas classificações do alarme
   */
  getAlarmsDetailsByInstallation(params) {
    const http = new Http();
    const mappedParams = new AlarmByInstallationRequest(params);
    return http.post(urls.getAlarmsDetailsByInstallation, mappedParams)
      .then(({ data }) => data.map(item => new AlarmByInstallationResponse(item)));
  },
  /**
   Obtém detalhes de um alarme anunciador.
   * @param {String} alarmId busca por id do alarme
   */
  getAlarmDetails(alarmId) {
    const http = new Http();
    const params = new AlarmDetailRequest({ alarmId });
    return http.get(urls.getAlarmDetails(params))
      .then(response => new AlarmDetailResponse(response.data));
  },
  /**
   Obtém os eventos de um alarme anunciador.
   * @param {String} alarmId busca por id do alarme
   */
   getAlarmEvents(alarmId) {
    const http = new Http();
    const params = new AlarmEventsRequest({ alarmId });
    return http.get(urls.getAlarmEvents(params))
      .then(response => response.data.map(item => new AlarmEventsResponse(item)));
},
};
